import React from "react";
import { motion } from "framer-motion";

import qouteIcon from "../Images/hero-get-quote.svg";
import chatIcon from "../Images/hero-whatsapp.svg";
import callIcon from "../Images/hero-call.svg";

const Hero = () => {
  return (
    <>
      <section className="hero-section">

        {/* BACKGROUND OVERLAY */}
        <motion.div
          className="hero-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2 }}
        ></motion.div>

        {/* CONTENT */}
        <div className="hero-content container">

          <div className="hero-left">

            {/* HEADING */}
            <motion.h1
              className="hero-heading"
              initial={{ opacity: 0, y: 70 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 1,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              Reliable Wooden
              <motion.span
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  delay: 0.5,
                  duration: 0.8,
                }}
              >
                {" "}
                Packaging Solutions{" "}
              </motion.span>
              Since 2013
            </motion.h1>

            {/* DESCRIPTION */}
            <motion.p
              className="hero-desc"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                delay: 0.4,
                duration: 0.8,
              }}
            >
              Manufacturer & Supplier of Wooden Pallets,

              Boxes, Crates & Plywood Boxes for Industrial

              & Export Needs.
            </motion.p>

            {/* BUTTON */}
            <motion.a
              className="hero-btn"
              href="/products"
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{
                delay: 0.8,
                duration: 0.5,
              }}
              whileHover={{
                scale: 1.06,
                y: -2,
              }}
              whileTap={{ scale: 0.96 }}
            >
              Explore Products
            </motion.a>

          </div>

        </div>

        {/* FLOATING CONTACT BAR */}
       {/* FLOATING CONTACT BAR */}

<motion.div
  className="floating-contact"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{
    delay: 1,
    duration: 0.6,
  }}
>

  {[
    {
      icon: qouteIcon,
      text: "Get a Quote",
      className: "quote-box",
      link: "/contact-us",
    },

    {
      icon: chatIcon,
      text: "Chat with us",
      className: "whatsapp-box",

      /* WHATSAPP */

      link: "https://wa.me/919624065081",
    },

    {
      icon: callIcon,
      text: "Call us",
      className: "call-box",

      /* CALL */

      link: "tel:+919624065081",
    },
  ].map((item, index) => (

    <motion.a
      href={item.link}
      key={index}
      className={`floating-box ${item.className}`}

      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}

      transition={{
        delay: 1 + index * 0.12,
        duration: 0.4,
      }}

      whileHover={{
        scale: 1.04,
      }}

      whileTap={{ scale: 0.97 }}

      /* OPEN WHATSAPP IN NEW TAB */

      target={
        item.text === "Chat with us"
          ? "_blank"
          : "_self"
      }

      rel="noopener noreferrer"
    >

      <img src={item.icon} alt={`${item.text} Icon | Gurukrupa Wood Pvt. Ltd.`} />

      <span>{item.text}</span>

    </motion.a>

  ))}

</motion.div>
      </section>
    </>
  );
};

export default Hero;